import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { useFormik } from 'formik';
import { passwordStrength } from 'check-password-strength';

import { RecoveryPasswordViewPropsType } from './types';
import './style.css';
import CustomIcon from '@Assets/images/icons';
import { useIntl } from 'react-intl';
import Api from '@Api/index';
import PasswordMeter from '@Components/Password/components/PasswordMeter';
import { Header, Text } from '@Components/Text';
import {
	TextBtnSubmit,
	ContainerStyled,
	ContainerSubtitle,
	ErrorText,
	SubTitle,
	SubTitleBlue,
} from '../styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { ContainerIcon } from '@Components/Password/styled';
import { ContainerSuccess } from './styled';
const initialValues = {
	password: '',
	changepassword: '',
	acceptTerms: false,
};

const RecoveryPasswordSchema = Yup.object().shape({
	password: Yup.string()
		.min(6, 'AUTH.VALIDATE.MIN.CARACTERS')
		.max(50, 'AUTH.VALIDATE.MAX.CARACTERS')
		.required('AUTH.VALIDATE.REQUIRED.PASSWORD'),
	changepassword: Yup.string()
		.required('AUTH.VALIDATE.REQUIRED.PASSWORD')
		.oneOf([Yup.ref('password')], 'AUTH.VALIDATE.REQUIRED.FIRST.PASSWORD')
		.when('password', {
			is: (val: string) => (val && val.length > 0 ? true : false),
			then: Yup.string().oneOf(
				[Yup.ref('password')],
				'AUTH.VALIDATE.REQUIRED.CONFIRM.PASSWORD'
			),
		}),
	acceptTerms: Yup.bool().required('AUTH.VALIDATE.TERMS&CONDIT'),
});

const ResetPassword: React.FC<RecoveryPasswordViewPropsType> = () => {
	const [status2, setStatus] = useState('');

	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<
		{ message: { description: string } } | undefined
	>(undefined);

	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
	const [strenghOfPassword, setStrenghOfPassword] = useState('');
	const [textOfStrengthOfPassword, setTextOfStrengthOfPassword] =
		useState<String | null>(null);
	const switchShowPassword = () => setShowPassword(!showPassword);
	const switchShowPasswordConfirm = () =>
		setShowPasswordConfirm(!showPasswordConfirm);

	const query = new URLSearchParams(useLocation().search);
	const tokenPassword: string | null = query.get('token');

	const formik = useFormik({
		initialValues,

		validationSchema: RecoveryPasswordSchema,
		onSubmit: async (valuesForm) => {
			setLoading(true);
			console.log('Submit');
			try {
				const { status, values } = await Api.Users.recoveryPassword(
					tokenPassword ?? '',
					valuesForm.password
				);
				setLoading(false);
				setStatus(status as string);
			} catch (error) {
				console.log(error, 'error2');
				setLoading(false);
				setErrors(error);
			}
		},
	});
	const { values } = formik;
	const intl = useIntl();

	const STRONG_TEXT_PASSWORD = {
		'Too weak': 'AUTH.PASSWORD.METER.TOOWEAK',
		Weak: 'AUTH.PASSWORD.METER.WEAK',
		Medium: 'AUTH.PASSWORD.METER.MEDIUM',
		Strong: 'AUTH.PASSWORD.METER.STRONG',
	};

	const checkPasswordStrength = (password: string) => {
		const strength = passwordStrength(values.password).value;
		console.log(formik);

		setStrenghOfPassword(strength);
		const text =
			STRONG_TEXT_PASSWORD[strength as keyof typeof STRONG_TEXT_PASSWORD];
		setTextOfStrengthOfPassword(intl.formatMessage({ id: text }));
	};
	useEffect(() => {
		if (formik.values.password.length > 0) {
			checkPasswordStrength(values.password);
		} else {
			setStrenghOfPassword('');
			setTextOfStrengthOfPassword(null);
		}
	}, [[formik.values.password.length, strenghOfPassword]]);

	return status2 === 'success' ? (
		<ContainerSuccess>
			<div className="">
				<div className="text-center mb-10">
					<div className="div mb-4">
						<CustomIcon icon="checkCircle" />
					</div>
					<Header className=" mb-3 mt-5 pt-5" variant="h1" weight="bold">
						{intl.formatMessage({
							id: 'AUTH.REGISTER.PASSCHANGEDVIEW.1',
						})}
					</Header>
					<SubTitle className="mt-5">
						{intl.formatMessage({
							id: 'AUTH.RECOVERY.PASSWORD.SUCCES',
						})}
					</SubTitle>
				</div>
			</div>
			<div className="d-flex flex-wrap justify-content-center pb-lg-0">
				<Link to="/auth/login">
					<SubTitleBlue>
						{intl.formatMessage({
							id: 'AUTH.REGISTER.REGISTERSENDVIEW.6',
						})}
					</SubTitleBlue>
				</Link>{' '}
			</div>
		</ContainerSuccess>
	) : errors && errors?.message.description === 'UUID was used' ? (
		<>
			<div className="form  fv-plugins-bootstrap5 fv-plugins-framework">
				<div className="text-center mb-10">
					<div className="div mb-4">
						<CustomIcon icon="alertSignRed" className="" />
					</div>
					<Header className=" mb-3 mt-5 pt-5" variant="h1" weight="bold">
						{intl.formatMessage({
							id: 'AUTH.RECOVERY.PASSWORD.ERROR.TITLE',
						})}
					</Header>
					<SubTitle className="mt-5">
						{intl.formatMessage({
							id: 'AUTH.RECOVERY.PASSWORD.ERROR.UID',
						})}
					</SubTitle>
				</div>
			</div>

			<div className="d-flex flex-wrap justify-content-center pb-lg-0">
				<Link to="/auth/forgot-password">
					<SubTitleBlue>
						{intl.formatMessage({
							id: 'AUTH.RECOVERY.PASSWORD.ERROR.BTN',
						})}
					</SubTitleBlue>
				</Link>{' '}
			</div>
		</>
	) : (
		<ContainerStyled>
			<form
				className="form "
				noValidate
				id="kt_login_password_reset_form"
				onSubmit={formik.handleSubmit}
			>
				<div className="text-center mb-8">
					{/* begin::Title */}
					{/* <h1 className="text-dark mb-3"> */}
					<Header weight="bold" variant="h1">
						{intl.formatMessage({ id: 'AUTH.REGISTER.RESETPASSWORD.1' })}
					</Header>
					{/* </h1> */}
					{/* end::Title */}

					{/* begin::Link */}
					<ContainerSubtitle>
						<SubTitle>
							{intl.formatMessage({ id: 'AUTH.REGISTER.RESETPASSWORD.2' })}
						</SubTitle>
						{/* <p className="d-flex pt-4 justify-content-end">
						</p> */}
						<Link
							className="d-flex justify-content-start align-items-center  p-0 "
							to="/auth/login"
						>
							<button
								type="button"
								id="kt_login_password_reset_form_cancel_button"
								className="btn p-0"
								disabled={formik.isSubmitting || !formik.isValid}
							>
								<SubTitleBlue>
									{intl.formatMessage({ id: 'AUTH.REGISTER.RESETPASSWORD.3' })}
								</SubTitleBlue>
							</button>
						</Link>{' '}
					</ContainerSubtitle>
					{/* end::Link */}
				</div>

				{/* begin::Form group */}
				{/* begin::Form group Password */}
				<div className="mb-8 fv-row" data-kt-password-meter="true">
					<div className="mb-1">
						<label>
							<Text weight="extra-bold">
								{intl.formatMessage({ id: 'AUTH.PASSWORD' })}
							</Text>
						</label>
						<div className="position-relative mb-3">
							<input
								type={showPassword ? 'text' : 'password'}
								placeholder={intl.formatMessage({
									id: 'AUTH.PLACEHOLDER.PASSWORD',
								})}
								autoComplete="off"
								{...formik.getFieldProps('password')}
								className={clsx(
									'form-control form-control-lg form-control-solid pr-100px '
								)}
							/>
							{formik.touched.password && !formik.errors.password && (
								<FontAwesomeIcon
									icon={faCheck}
									color="#50CD89"
									style={{
										height: '1.929rem',
										width: '1.929rem',
										marginRight: '0.357rem',
										marginTop: '-0.143rem',
									}}
									className={clsx(`position-absolute top-0 end-0 pt-4 pe-12  `)}
								/>
							)}
							{formik.touched.password && formik.errors.password && (
								<ContainerIcon>
									<FontAwesomeIcon
										icon={faExclamation}
										color="#f1416c"
										style={{
											height: '1.071rem',
											width: '1.214rem',
											display: 'flex',
											justifyContent: 'center',
										}}
									/>
								</ContainerIcon>
							)}
							<CustomIcon
								icon={showPassword ? 'eyeOpen' : 'eyePassword'}
								onClick={switchShowPassword}
								className={clsx(
									`position-absolute top-0 end-0 pt-4 pe-5  bg-transparent btn`
								)}
							/>

							{formik.touched.password && formik.errors.password && (
								<div className="fv-plugins-message-container ">
									<div className="fv-help-block">
										<span role="alert" className="mt-3">
											<ErrorText>
												{intl.formatMessage({ id: formik.errors.password })}
											</ErrorText>
										</span>
									</div>
								</div>
							)}
						</div>
						{/* begin::Meter */}
						<PasswordMeter strength={strenghOfPassword} />

						{/* end::Meter */}
					</div>
					<div className="text-muted">
						{textOfStrengthOfPassword === null
							? intl.formatMessage({ id: 'AUTH.PASSWORD.METER' })
							: textOfStrengthOfPassword}
					</div>
				</div>
				{/* end::Form group */}

				{/* begin::Form group Confirm password */}
				<div className="fv-row mb-5 position-relative">
					<div className="mb-1">
						<label>
							<Text weight="extra-bold">
								{intl.formatMessage({ id: 'AUTH.REGISTER.STEP2.5' })}
							</Text>
						</label>
						<div className="position-relative mb-3">
							<input
								type={showPasswordConfirm ? 'text' : 'password'}
								placeholder={intl.formatMessage({
									id: 'AUTH.PLACEHOLDER.PASSWORD',
								})}
								autoComplete="off"
								{...formik.getFieldProps('changepassword')}
								className={clsx(
									'form-control form-control-lg form-control-solid pr-100px '
								)}
							/>
							{formik.touched.changepassword &&
								!formik.errors.changepassword && (
									<FontAwesomeIcon
										icon={faCheck}
										color="#50CD89"
										style={{
											height: '1.929rem',
											width: '1.929rem',
											marginRight: '0.357rem',
											marginTop: '-0.143rem',
										}}
										className={clsx(
											`position-absolute top-0 end-0 pt-4 pe-12  `
										)}
									/>
								)}
							{formik.touched.changepassword &&
								formik.errors.changepassword && (
									<ContainerIcon>
										<FontAwesomeIcon
											icon={faExclamation}
											color="#f1416c"
											style={{
												height: '1.071rem',
												width: '1.214rem',
												display: 'flex',
												justifyContent: 'center',
											}}
										/>
									</ContainerIcon>
								)}
							<CustomIcon
								icon={showPasswordConfirm ? 'eyeOpen' : 'eyePassword'}
								onClick={switchShowPasswordConfirm}
								className={clsx(
									`position-absolute top-0 end-0 pt-4 pe-5  bg-transparent btn`
								)}
							/>
						</div>
					</div>
					{formik.touched.changepassword && formik.errors.changepassword && (
						<div className="fv-plugins-message-container ">
							<div className="fv-help-block">
								<span role="alert" className="mt-3">
									<ErrorText>
										{intl.formatMessage({ id: formik.errors.changepassword })}
									</ErrorText>
								</span>
							</div>
						</div>
					)}
				</div>

				{/* end::Form group */}

				<div className="d-flex flex-wrap justify-content-center pb-lg-0 ">
					{/* <Link className="w-100" to="/auth/forgot-password-sent-email"> */}
					<button
						type="submit"
						id="kt_password_reset_submit"
						className="col-12 btn btn-lg btn-primary fw-bolder mt-2 mb-3"
					>
						{!loading && (
							<span className="indicator-label ">
								<TextBtnSubmit>
									{intl.formatMessage({ id: 'BTN.CHANGEPASSWORD' })}
								</TextBtnSubmit>
							</span>
						)}

						{loading && (
							<span
								className="indicator-progress"
								style={{ display: 'flex', justifyContent: 'center' }}
							>
								<TextBtnSubmit>
									{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.16' })}{' '}
								</TextBtnSubmit>
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						)}
					</button>
					{/* </Link> */}
				</div>

				{/* end::Form group */}
			</form>
		</ContainerStyled>
	);
};

export default ResetPassword;
